<template>
  <div class="container search_result_box">
    <div class="row" v-if="!no_results">
      <div class="col-4">

        <div class="suggestions" v-if="suggestions.length > 0">
          <h3>{{$t('suggestion')}}</h3>
          <div v-for="(item, index) in suggestions" :key="index" class="suggestion pointer" @click="clickSubmitForm({query: item})" ref="resElem" tabindex="0">
            <span v-html="highlight(item)"></span>
          </div>
        </div>

        <div class="w-100" :class="{hr: categories.length > 0 && suggestions.length > 0}"></div>

        <div class="categories">
          <h3>{{$t('category')}}</h3>
          <div v-if="categories.length > 0">
            <div v-for="(item, index) in categories" :key="index" class="category pointer dropdown-item" @click="clickCategory(item)" @keyup.enter="clickCategory(item)" ref="resElem" tabindex="0">
              <span class="prefix" v-html="highlight(item.prefix)"></span>
              <span v-if="item.main" class="fas fa-angle-down ml-2"></span>
              <span class="main" v-html="highlight(item.main)"></span>
            </div>
          </div>
          <div v-else>
            Keine Ergebnisse gefunden
          </div>
        </div>

      </div>

      <div class="col-8">
        <div class="projects" v-for="(project, index) in projects" :key="index">
          <h3 class="pointer" @click="clickProject(project.info)">
            {{$tc('project', project.products.length)}}
          </h3>
          <div class="flex">
            <div v-for="(item, index) in project.products" :key="index" class="product pointer col-3" @click="clickProduct(item)" @keyup.enter="clickProduct(item)" ref="resElem" tabindex="0">
              <div class="image">
                <img class="itemImage img-fluid" :src="item.image">
              </div>
              <div class="product-info-wrapper">
                <div class="text-truncate" v-html="highlight(item.title)"></div>
                <div class="text-muted font-weight-light" v-html="$t('artnum') + ': ' + highlight(item.ordernumber)"></div>
              </div>
            </div>
          </div>
          <div class="row info">
            <div class="col" @click="clickProject(project.info)">{{$t('link2projects')}}</div>
          </div>
        </div>

        <div class="products" v-if="products.length > 0">
            <h3>{{$tc('products', products.length)}}</h3>
            <div class="flex">
              <div v-for="(item, index) in products" :key="index" class="product pointer col-3" @click="clickProduct(item)" @keyup.enter="clickProduct(item)" ref="resElem" tabindex="0">
                <div class="image">
                  <img class="itemImage img-fluid" :src="item.image">
                </div>
                <div class="product-info-wrapper">
                  <div class="text-truncate" v-html="highlight(item.title)"></div>
                  <div class="text-muted font-weight-light" v-html="$t('artnum') + ': ' + highlight(item.ordernumber)"></div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    <div class="row info" v-if="!no_results">
      <div class="col" @click="clickSubmitForm({query})">{{$t('findAll')}} <strong>{{ query }}</strong></div>
    </div>

    <div class="row noresults" v-if="no_results">
      <div class="col">{{$t('no_result_for')}} <strong>{{ query }}</strong></div>
    </div>
  </div>
</template>

<script>
import searchResults from "./class/searchResults";

export default {
  name: "searchResultsTableDesktop",
  mixins: [searchResults],
  computed: {}
}
</script>

<style scoped>
  @media (min-width:1200px) {
    .search_result_box {
      left: -355px;
      width: 1100px;
    }
  }

  @media (min-width:1060px) {
    .search_result_box {
      left: -430px;
      width: 1100px;
    }
  }

  .search_result_box {
    position: absolute;
    background-color: #f5f5f5;
    z-index: 1000;

    border-radius: 10px;
    padding: 15px;
  }

  .suggestions {
    margin-bottom: 15px;
  }

  .categories {
    margin-bottom: 15px;
  }

  .categories .category {
    margin-bottom: 15px;
    padding: 0;
  }

  .category .main {
    display: block;
  }

  .hr {
    margin-bottom: 15px;
    border-bottom: 1px solid #ced4da;
  }

  .products .flex,
  .projects .flex {
    display: flex;
    flex-wrap: wrap;
  }

  .products .product,
  .projects .product  {
    border-radius: 10px;
    padding: 10px;
    text-align: center;
  }

  .product .image {
    display: flex;
    aspect-ratio: 1;
    padding: 10px;
    border-radius: 10px;
    background-color: #fff;
  }

  .products .product .product-info-wrapper,
  .projects .product .product-info-wrapper {
    margin-top: 7px;
    text-align: left;
  }

  .info {
    margin-top: 15px;
    text-align: right;
    color: #3e5c9a;
    cursor: pointer;
    text-decoration: none;
  }

  .info:hover {
    text-decoration: underline;
  }

  .noresults {
    text-align: center;
  }

  .pointer {
    cursor: pointer
  }

  .pointer:focus,
  .pointer:hover {
    background-color: #ced4da;
  }
</style>

<style>
  span.highlight {
    font-weight: bold;
    color: #3e5c9a;
  }
</style>
